module.exports = __webpack_public_path__ + "static/media/icon_facial.2347bc78.png";